import { createSelector } from 'reselect';

export const selectedFeeNotes = (state: any) => {
  return state.get('feeNotes');
};
export const makeSelectFeeNotes = () =>
  createSelector(selectedFeeNotes, notes => {
    if (notes && notes.get('feeNotes')) {
      return notes.get('feeNotes').toJS();
    }
    return [];
  });
export const makeSelectAllFeeNotes = () =>
  createSelector(selectedFeeNotes, notes => {
    if (notes && notes.get('allFeeNotes')) {
      return notes.get('allFeeNotes').toJS();
    }
    return [];
  });
export const makeSelectCountFeeNotes = () =>
  createSelector(selectedFeeNotes, notes => {
    if (notes && notes.get('feeNotesCount')) {
      return notes.get('feeNotesCount');
    }
    return 0;
  });

export const makeSelectKpiOverDueInvoice = () =>
  createSelector(selectedFeeNotes, notes => {
    if (notes && notes.get('kpiOverDueInvoice')) {
      return notes.get('kpiOverDueInvoice').toJS();
    }
    return {};
  });
